import React from "react";
import { IconFont } from "../../../../icon-font/iconfont";
import pruforceBg from "../../../../components/icon/assets/candidate_pruforce_bg.svg";
import defaultAvatar from "../../../../components/icon/assets/default-avatar.png";
import editLogo from "../../../../components/icon/assets/edit.svg";
import emailLogo from "../../../../components/icon/assets/email.svg";
import female from "../../../../components/icon/assets/female.svg";
import licenseExamLogo from "../../../../components/icon/assets/license-exam.svg";
import logoutLogo from "../../../../components/icon/assets/logout.svg";
import male from "../../../../components/icon/assets/male.svg";
// import prudnaLogo from "../../../../components/icon/assets/prudna.svg";//PHKL Custom
import settingLogo from "../../../../components/icon/assets/setting.svg";
// import trainingLogo from "../../../../components/icon/assets/training.svg";//PHKL Custom
import mockExamLogo from "../../../../components/icon/assets/mock-exam.svg"; // Add mock exam logo
import examRegisterIcon from "../../../../components/icon/assets/exam-register.svg"; //PHKL Custom
import { useCandidateHome } from "./candidate-home.hook";
import { CandidateStatus } from "../../types";
import styles from "./candidate-home.module.css";
import { LicenseExamEntranceCardComponent } from "./components/license-exam-entrance-card/license-exam-entrance-card.component";
import { MockExamEntranceCardComponent } from "./components/license-exam-entrance-card/mock-exam-entrance-card/mock-exam-entrance-card.component";
import { OnboardingTrainingSectionComponent } from "./components/onboarding-training-section";
import { isStandalone } from "../../../../utils/standalone";
import { getDeviceAndBrowserType } from "../../../../utils/hooks/use-a2hs";
import { textStyleSet } from "../../../../mui-theme/text.style";
import { useSetting } from "../setting/setting.hook";
import { IOSSwitch } from "../../../../components/switch/ios-switch";
import { CircularProgress } from "@mui/material";
import { color } from "../../../../mui-theme/palette";
import { PHKLPrudnaSectionComponent } from "./components/prudna-section/phkl-prudna-section.component";
import { IconFontLayer } from "../../../../icon-font/iconfont-layer"; //PHKL Custom

type CandidateHomeProps = {};

export const CandidateHomeScreen = (props: CandidateHomeProps) => {
  const {
    t,
    clickInbox,
    clickSetting,
    clickProfile,
    clickLogout,
    // handleGuideClick,//PHKL Custom
    handleDisclaimerClick,
    handlePrivacyPolicyClick,
    handleLanguageClick,
    clickPopup,
    candidateProfile,
    isSettingPopupOpen,
    labelOption,
    inboxUnreadCount,
    clickLicenseExam,
    // clickPrudna,//PHKL Custom
    // clickTraining,//PHKL Custom
    clickMockExam,
    clickOnboardingTraining,
    enableOnboardingExamRegistry,
    enableMockExam,
    handleEnableShortcut,
    showEnableNotificationBanners,
    closeEnableNotificationBanners,
    loading, // PHKL Custom
    MENU_TIEMS, // PHKL Custom
    enableStandardSSO,
    enableReportPRUDNA,
  } = useCandidateHome();

  const { pushNotificationEnabled, togglePushNotification, toggling } = useSetting();
  const { device } = getDeviceAndBrowserType();
  return (
    <div className={styles.container}>
      {/* Header section */}
      <header className={styles.header}>
        <img src={pruforceBg} alt=""></img>
        <div className={styles.operation}>
          {/* PHKL Custom: -s */}
          {/* {device === "ios" ? (
            <div onClick={handleGuideClick} className={styles.logoContainer}>
              <IconFont name="bookmark" size={24} />
            </div>
          ) : null} */}
          {/* PHKL Custom: -e */}

          <div className={styles.logoContainer} onClick={clickInbox}>
            <img src={emailLogo} alt="" className={styles.logoImg} />
            {inboxUnreadCount ? (
              <div className={styles.countTextContainer}>
                <span className={styles.countText}>
                  {inboxUnreadCount <= 99 ? inboxUnreadCount : "99+"}
                </span>
              </div>
            ) : null}
          </div>
          <img src={settingLogo} alt="" className={styles.logoImg} onClick={clickSetting} />
          <img src={logoutLogo} alt="" className={styles.logoImg} onClick={clickLogout} />
        </div>
      </header>
      {/* PHKL Custom: -s */}
      {/* {showEnableNotificationBanners ? (
        <div className="bg-white">
          <div
            style={textStyleSet.text_11_med}
            className="flex flex-row items-center bg-orangeLight text-grey66 mx-4 mt-4 px-3 py-2 rounded-lg"
          >
            <div className="flex-1">
              <span className={styles.bannerText}>
                {t("Common.enable_notifications_avoid_missing_important_info")}
              </span>
              <span onClick={handleGuideClick} className="text-orange pl-3">
                {t("Common.view_detail")}
              </span>
            </div>
            */}
      {/* close icon */}
      {/*
            <div className="flex-none cursor-pointer" onClick={closeEnableNotificationBanners}>
              <IconFont name="close" size={24} color="#B2B2B2" />
            </div>
          </div>
        </div>
      ) : null} */}
      {/* PHKL Custom: -e */}

      {
        //PHKL Custom -s
        // COE Original Layout
        // {/* profile section */}
        // <div className={styles.profileContainer}>
        //   <div className={styles.profile}>
        //     <div className="px-5 pt-5 pb-10 aspect-ratio-1-1:rounded-xl bg-white">
        //       <div className={styles.profileHeader}>
        //         <div className={styles.profilePictureContainer}>
        //           <img
        //             src={candidateProfile?.profile_img_url || defaultAvatar}
        //             alt=""
        //             className={styles.profileImage}
        //           />
        //           <div className={styles.overlay} onClick={clickProfile}>
        //             <img src={editLogo} alt="" className={styles.editIcon} />
        //           </div>
        //         </div>
        //         <div className={styles.profileInfo}>
        //           <div className={styles.nameSex}>
        //             <h2 className={styles.profileName}>
        //               {candidateProfile?.firstname} {candidateProfile?.lastname}
        //             </h2>
        //             {/* PHKL Custom -s
        //             <img
        //               src={candidateProfile?.gender === "F" ? female : male}
        //               alt=""
        //               className={styles.sexImg}
        //             />
        //             PHKL Custom -e  */}
        //           </div>
        //           {/* PHKL Custom -s
        //           <span
        //             className={styles.profileStatus}
        //             style={{
        //               backgroundColor: labelOption(candidateProfile?.status as CandidateStatus)
        //                 ?.backgroundColor,
        //               color: labelOption(candidateProfile?.status as CandidateStatus)?.color,
        //             }}
        //           >
        //             {labelOption(candidateProfile?.status as CandidateStatus)?.text}
        //           </span>
        //           PHKL Custom -e  */}
        //         </div>
        //       </div>
        //       <div className={styles.actions}>
        //         {/* //PHKL Custom - s
        //         <div className={styles.actionItem} onClick={clickPrudna}>
        //           <img src={prudnaLogo} alt="" className={styles.actionIcon}></img>
        //           <span className={styles.text}>{t("Common.prudna")}</span>
        //         </div>
        //          <div className={styles.actionItem} onClick={clickTraining}>
        //           <img src={trainingLogo} alt="" className={styles.actionIcon}></img>
        //           <span className={styles.text}>{t("Common.training")}</span>
        //         </div>
        //          //PHKL Custom - e */}
        //         {/* PHKL Custom -s*/}
        //         <div className={styles.actionItem} onClick={clickLicenseExam}>
        //           <img src={examRegisterIcon} alt="" className={styles.actionIcon}></img>
        //           <span className={styles.text}>{t("Recruitment.license_exam")}</span>
        //         </div>
        //         {enableMockExam &&
        //           MENU_TIEMS.map((item: any) => {
        //             return (
        //               <div className={styles.actionItem} onClick={item.onClick} key={item.id}>
        //                 <img src={item.icon} alt="" className={styles.actionIcon} />
        //                 <span className={styles.text}>{t(item.label)}</span>
        //               </div>
        //             );
        //           })}
        //         {/* PHKL Custom -e*/}
        //         {/* <div className={styles.actionItem} onClick={clickPrudna}>
        //           <img src={prudnaLogo} alt="" className={styles.actionIcon}></img>
        //           <span className={styles.text}>{t("Common.prudna")}</span>
        //         </div> */}
        //         <OnboardingTrainingSectionComponent
        //           type="shortcut"
        //           onClick={clickOnboardingTraining}
        //         />
        //       </div>
        //     </div>
        //     {/* PHKL Custom: -s */}
        //     {enableReportPRUDNA && <PHKLPrudnaSectionComponent />}
        //     {loading ? (
        //       <div style={{ flex: 1, textAlign: "center", marginTop: 30 }}>
        //         <CircularProgress sx={{ color: "grey.500" }} color="inherit" size="20px" />
        //       </div>
        //     ) : (
        //       //  : enableOnboardingExamRegistry ? (
        //       //   <LicenseExamEntranceCardComponent />
        //       // ) : null}
        //       // {/* PHKL Custom: -e */}
        //       // {enableMockExam ? <MockExamEntranceCardComponent /> : null}
        //       // {/* PHKL Custom */}
        //       // )
        //       <>
        //         {/* Display logic changed in ticket PHKLAEB-2540. so far LicenseExam & MockExam widget always show*/}
        //         <LicenseExamEntranceCardComponent />
        //         <MockExamEntranceCardComponent />
        //       </>
        //     )}
        //     {/* PHKL Custom -e*/}
        //     <OnboardingTrainingSectionComponent />
        //   </div>
        // </div>
      }
      {/* PHKL Layout */}
      <div className={styles.profileContainer}>
        <div className={styles.profile}>
          <div className="px-3 pt-4 pb-2 md:px-0">
            <div className="bg-white rounded-2xl px-5 pt-5 pb-8">
              {/* ===== Header ===== */}
              <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-start">
                {/* Left section */}
                <div className="flex w-full flex-row gap-4 items-stretch">
                  {/* Avatar */}
                  <div className={styles.profilePictureContainer}>
                    <img
                      src={candidateProfile?.profile_img_url || defaultAvatar}
                      alt=""
                      className={styles.profileImage}
                    />
                  </div>

                  {/* Right section */}
                  <div className="flex flex-col flex-1 justify-center min-h-[80px]">
                    <h2 className="text-2xl font-semibold leading-tight">
                      {candidateProfile?.firstname} {candidateProfile?.lastname}
                    </h2>

                    {/* Mobile edit button */}
                    <button
                      onClick={clickProfile}
                      className="
                        mt-4
                        w-full
                        md:hidden
                        h-[30px]
                        px-4 py-[4px]
                        flex items-center justify-center gap-2
                        bg-white
                        border-2 border-[#B3B3B3]
                        rounded
                        text-sm text-gray-800
                        active:bg-gray-100
                      ">
                      <IconFontLayer
                        size={18}
                        backgroundSize={18}
                        containerStyle={{
                          borderWidth: 0,
                          justifySelf: "center",
                        }}
                        name="edit1"
                      />
                      <span>{t("Common.edit")}</span>
                    </button>
                  </div>
                </div>

                {/* Web edit button */}
                <button
                  onClick={clickProfile}
                  className="
                    hidden md:flex
                    w-full md:w-auto h-[30px]
                    items-center justify-center gap-2
                    px-4 py-[4px]
                    bg-white
                    border-2 border-[#B3B3B3]
                    rounded
                    text-sm text-gray-800
                    active:bg-gray-100
                    whitespace-nowrap
                  ">
                  <IconFontLayer
                    size={18}
                    backgroundSize={18}
                    containerStyle={{
                      borderWidth: 0,
                      justifySelf: "center",
                    }}
                    name="edit1"
                  />

                  <span>{t("Common.edit")}</span>
                </button>
              </div>

              {/* ===== Actions ===== */}
              <div className={styles.actions}>
                <div className={styles.actionItem} onClick={clickLicenseExam}>
                  <img src={examRegisterIcon} alt="" className={styles.actionIcon} />
                  <span className={styles.text}>{t("Recruitment.license_exam")}</span>
                </div>

                {enableMockExam &&
                  MENU_TIEMS.map((item: any) => (
                    <div className={styles.actionItem} onClick={item.onClick} key={item.id}>
                      <img src={item.icon} alt="" className={styles.actionIcon} />
                      <span className={styles.text}>{t(item.label)}</span>
                    </div>
                  ))}
                <OnboardingTrainingSectionComponent
                  type="shortcut"
                  onClick={clickOnboardingTraining}
                />
              </div>
            </div>
          </div>
          {enableReportPRUDNA && <PHKLPrudnaSectionComponent />}
          {loading ? (
            <div style={{ flex: 1, textAlign: "center", marginTop: 30 }}>
              <CircularProgress sx={{ color: "grey.500" }} color="inherit" size="20px" />
            </div>
          ) : (
            <>
              {/* Display logic changed in ticket PHKLAEB-2540. so far LicenseExam & MockExam widget always show*/}
              <LicenseExamEntranceCardComponent />
              <MockExamEntranceCardComponent clickMockExam={clickMockExam}/>
            </>
          )}
          <OnboardingTrainingSectionComponent />
          <div className="h-5"></div>
        </div>
      </div>
      {/* PHKL Custom -e*/}

      {isSettingPopupOpen && (
        <div className={styles.settingOverlay} onClick={clickPopup}>
          <div className={styles.popup}>
            <ul>
              <li className={styles.popupItem} onClick={handleLanguageClick}>
                {t("Common.language")}
              </li>
              {isStandalone() ? null : (
                <li className={styles.popupItem} onClick={handleEnableShortcut}>
                  {t("Common.enable_shortcut")}
                </li>
              )}
              <li className={styles.popupItem}>
                <div className="flex-1">{t("Common.push_notification")}</div>
                <div className="self-end">
                  <IOSSwitch
                    checked={pushNotificationEnabled}
                    onChange={togglePushNotification}
                    loading={toggling}
                    disabled={toggling}
                    color="primary"
                  />
                </div>
              </li>
              <li className={styles.popupItem} onClick={handlePrivacyPolicyClick}>
                {t("Common.privacy_notice")}
              </li>
              <li className={styles.popupItem} onClick={handleDisclaimerClick}>
                {t("Common.disclaimer")}
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
